import LayoutBackend from '@/layouts/variations/Backend.vue';
import { checkAuth, beforeEnterForm } from '@/router/helpers.js';

const CommunityConverter = () =>
  /* webpackChunkName: "group-community" */ import('@/views/Community/Converter.vue');
const MobileCommunityGuide = () =>
  /* webpackChunkName: "group-community" */ import('@/views/Community/Guide.vue');
const CommunityForm = () =>
  /* webpackChunkName: "group-community" */ import('@/views/Community/Form.vue');
const InfluencerForm = () =>
  /* webpackChunkName: "group-community" */ import('@/views/Community/InfluencerForm.vue');
const GradeForm = () =>
  /* webpackChunkName: "group-community" */ import('@/views/Community/GradeForm.vue');
const community = [
  {
    path: '/community',
    name: 'Community',
    redirect: '/community/home',
    component: LayoutBackend,
    children: [
      {
        path: 'home',
        component: CommunityConverter,
        beforeEnter: checkAuth(),
      },
      {
        path: 'guide',
        name: 'CommunityGuide',
        component: MobileCommunityGuide,
        beforeEnter: checkAuth(),
      },
      {
        path: 'form',
        name: 'CommunityForm',
        component: CommunityForm,
        beforeEnter: beforeEnterForm(),
      },
      {
        path: 'edit',
        name: 'EditCommunity',
        component: CommunityForm,
        beforeEnter: beforeEnterForm(),
      },
      {
        path: 'influencerform',
        name: 'InfluencerForm',
        component: InfluencerForm,
        beforeEnter: beforeEnterForm(),
      },
      {
        path: 'gradeform',
        name: 'UpgradeCommunity',
        component: GradeForm,
        beforeEnter: beforeEnterForm(),
      },
      {
        path: 'influenceredit',
        name: 'EditInfluencer',
        component: InfluencerForm,
        beforeEnter: beforeEnterForm(),
      },
    ],
  },
];

export { community };
